import {PIXELS_TO_REM_RATIO} from '../../constants';
import {SizeUnit} from '../../Properties';
import {PERCENTAGE_TO_PIXELS_CONVERSION_FUNCTIONS} from './conversionFunctions';
import {CSSProperty, EnrichedAstNode} from '../../../types';
import {convertAutoToNumeric} from '../../utils/changeNumericCSSValue';

interface Args {
    cssKey: CSSProperty;
    value: number;
    unit: SizeUnit;
    fontSize: number;
    node: EnrichedAstNode;
    parentFontSize: number;
    parentHeight: number;
    parentWidth: number;
    previewWidth: number;
}

/**
 * @description
 * Given a value and a unit, convert that value to pixels. Since `em` and `percentage` are relative units we have to
 * pass in some extra data to be able to make the conversion. The `parentFontSize`, `parentWidth`, `fontSize`, and
 * `parentHeight` need to be in pixels, since1 that's the unit we're converting to.
 */
export const convertValueToPixels = ({
    cssKey,
    value,
    unit,
    fontSize,
    node,
    parentFontSize,
    parentHeight,
    parentWidth,
    previewWidth,
}: Args) => {
    const isFontSize = cssKey === 'fontSize';

    switch (unit) {
        case 'px':
            return value;
        case 'em':
            if (isFontSize) {
                return value * parentFontSize;
            }
            return value * fontSize;
        case 'rem':
            return value * PIXELS_TO_REM_RATIO;
        case 'vw':
            return previewWidth * (value / 100);
        case '%':
            return (
                PERCENTAGE_TO_PIXELS_CONVERSION_FUNCTIONS[cssKey as string]?.({
                    percentage: value,
                    styles: node.styles,
                    parentWidth,
                    parentHeight,
                    parentFontSizePx: parentFontSize,
                    fontSizePx: fontSize,
                    node,
                }) || value
            );
        case 'auto':
            return convertAutoToNumeric(cssKey, 'auto', node);
        default:
            return value;
    }
};
